const Utils = {

	init: function() {

		// Last position of scroll.
		this.last_position = $(window).scrollTop();
	},

	// Gets scroll direction based on previous y position.
	scroll_direction: function() {

		// Determines if scroll direction is up or down.
		if(this.last_position > $(window).scrollTop()) {
			this.direction = "up";
			this.last_position = $(window).scrollTop();
		}
		else if(this.last_position < $(window).scrollTop()) {
			this.direction = "down";
			this.last_position = $(window).scrollTop();
		}

		return this.direction;
	}

};

export default Utils;